'use strict';

const processInclude = require('progamers_core/util');
// included outside document.ready for speed/lighthouse reasons
processInclude(require('./adform/adform'));
processInclude(require('./adform/adformProducts'));
processInclude(require('./adform/adformFeaturedBlock'));
processInclude(require('./adform/adformListPageBanner'));
processInclude(require('./adform/adformHomepageRecommendedProducts'));
processInclude(require('./adform/adformHomepageMainSlider'));
processInclude(require('./adform/adformCategoryBannerSlider'));
processInclude(require('./adform/adformPDPProductsSlider'));
